@if (isUpdateAvailable) {
<div class="update-notification">
  <div class="update-message">
    <i class="pi pi-refresh"></i>
    <span>{{ 'shell.updateAvailable' | transloco }}</span>
  </div>
  <button type="button" (click)="updateApp()">{{ 'shell.update' | transloco }}</button>
</div>
}

<p-toast position="top-center"></p-toast>

@if (isLoggedIn) {
<div class="erp-shell">
  <aside class="desktop-rail" [class.open]="desktopNavExpanded"
    (mouseenter)="openDesktopNav()" (mouseleave)="closeDesktopNav()"
    (focusin)="openDesktopNav()" (focusout)="closeDesktopNavOnFocusOut($event)">
    <div class="rail-head">
      <button type="button" class="rail-toggle" [attr.aria-expanded]="desktopNavExpanded"
        aria-controls="desktop-primary-nav" [attr.aria-label]="'shell.toggleNavigation' | transloco"
        (click)="toggleDesktopNav()">
        <i class="pi pi-bars"></i>
      </button>
      <a class="rail-brand" routerLink="/dashboard" (click)="navigateHome($event)"
        [attr.aria-label]="'shell.goToHome' | transloco" [attr.aria-hidden]="!desktopNavExpanded">
        <img src="/assets/logilink_logo_color.png" alt="">
        <span>LOGILINK</span>
      </a>
    </div>

    <nav id="desktop-primary-nav" class="drawer-nav desktop-nav" [attr.aria-label]="'shell.primaryNavigation' | transloco">
      @for (item of menu.visibleItems; track menu.trackItem($index, item)) {
      <ng-container *ngTemplateOutlet="navBranch; context: { $implicit: item, level: 0, mode: 'desktop' }"></ng-container>
      } @empty {
      <div class="nav-empty">{{ 'shell.noMatchingModules' | transloco }}</div>
      }
    </nav>

    <div class="rail-powered-by" [attr.aria-label]="'shell.poweredByCargoMate' | transloco">
      <span>{{ 'shell.poweredBy' | transloco }}</span>
      <img src="/assets/cargomate_logo.png" alt="CargoMate Logo">
    </div>
  </aside>

  <div class="shell-main">
    <header class="top-app-bar">
      <div class="app-bar-left">
        <button type="button" class="mobile-menu-btn" [attr.aria-label]="'shell.openNavigation' | transloco"
          (click)="mobileSidebarVisible = true">
          <i class="pi pi-bars"></i>
        </button>

        <a class="brand-lockup" routerLink="/dashboard" (click)="navigateHome($event)"
          [attr.aria-label]="'shell.goToHome' | transloco">
          <img src="/assets/logilink_logo_color.png" alt="LogiLink Logo">
          <span class="brand-name">LOGILINK</span>
        </a>

        @if (menu.currentPageTitle(); as pageTitle) {
        <span class="brand-separator" aria-hidden="true">|</span>
        <div class="page-context">
          <span>{{ pageTitle }}</span>
        </div>
        }

        @if (instanceTag) {
        <span class="instance-tag" [attr.title]="'shell.testInstance' | transloco" [attr.aria-label]="'shell.testInstance' | transloco">
          {{ instanceTag }}
        </span>
        }
      </div>

      <div class="app-bar-center">
        <app-global-search [term]="globalSearch.term" [open]="globalSearch.open" [loading]="globalSearch.loading"
          [groups]="globalSearch.groups" [highlightedIndex]="globalSearch.highlightedIndex"
          (termChange)="globalSearch.onChange($event)" (opened)="globalSearch.openSearch()" (blurred)="globalSearch.blur()"
          (keydownSearch)="globalSearch.keydown($event)" (cleared)="globalSearch.clear()"
          (resultSelected)="globalSearch.selectResult($event)"></app-global-search>
      </div>

      <div class="app-bar-actions">
        <app-tenant-scope-selector [currentCompany]="company" (scopeChange)="onTenantScopeChanged($event)"></app-tenant-scope-selector>

        <button type="button" class="theme-toggle-btn" (click)="toggleDarkMode()"
          [attr.aria-label]="'Switch to ' + themeToggleLabel()"
          [attr.title]="'Switch to ' + themeToggleLabel()">
          <i class="pi" [class.pi-moon]="!isDarkMode" [class.pi-sun]="isDarkMode"></i>
          <span>{{ isDarkMode ? ('shell.light' | transloco) : ('shell.dark' | transloco) }}</span>
        </button>

        @if (isAiChatDrawerAvailable) {
        <button type="button" class="ai-chat-btn" (click)="openAiChatDrawer()"
            [attr.aria-label]="'shell.openAiAssistant' | transloco" [attr.title]="'shell.aiAssistant' | transloco">
          <i class="fa-solid fa-robot"></i>
        </button>
        }

        @if (canInstallPwa && !isPwaInstalled) {
        <button type="button" class="install-btn" (click)="promptInstallPwa()" [attr.aria-label]="'shell.installLogiLink' | transloco"
          [attr.title]="'shell.installLogiLink' | transloco">
          <i class="pi pi-download"></i>
          <span>{{ 'shell.installApp' | transloco }}</span>
        </button>
        }

        <button type="button" class="user-profile-btn" (click)="profileMenu.toggle($event)"
          [attr.aria-label]="'shell.openAccountMenu' | transloco">
          <p-avatar [image]="customer?.imageUrl ?? 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'"
            shape="circle">
          </p-avatar>
          <div class="user-info-text">
            <span class="user-name">{{ customer?.name ?? ('shell.signedInUser' | transloco) }}</span>
            <span class="user-role">{{ userRoleLabel }}</span>
          </div>
          <i class="pi pi-chevron-down profile-chevron"></i>
        </button>

        <p-menu #profileMenu [model]="profileMenuItems" [popup]="true" appendTo="body"></p-menu>
      </div>
    </header>

    @if (showTrialBanner()) {
    <section class="trial-lifecycle-banner" [ngClass]="trialBannerClass()">
      <div class="trial-banner-copy">
        <i class="pi pi-clock"></i>
        <div>
          <strong>{{ trialBannerTitle() }}</strong>
          <span>{{ trialBannerMessage() }}</span>
        </div>
      </div>
      <div class="trial-banner-actions">
        <button type="button" class="trial-banner-btn" (click)="manageSubscription()">
          {{ 'trial.subscribeUpgrade' | transloco }}
        </button>
      </div>
    </section>
    }

    <main class="erp-content">
      <router-outlet></router-outlet>
    </main>

    <div class="productivity-launcher" [class.open]="productivityLauncherOpen">
      <div class="productivity-actions">
        <button pButton type="button" icon="pi pi-bell" class="productivity-action" [pTooltip]="'shell.notifications' | transloco"
          tooltipPosition="left" (click)="openProductivity('/productivity/notifications')">
          <span class="productivity-badge" *ngIf="productivitySummary.unreadNotifications">{{
            productivitySummary.unreadNotifications }}</span>
        </button>
        <button pButton type="button" icon="pi pi-check-square" class="productivity-action" [pTooltip]="'shell.tasks' | transloco"
          tooltipPosition="left" (click)="openProductivity('/productivity/tasks')">
          <span class="productivity-badge" *ngIf="productivitySummary.pendingTasks">{{ productivitySummary.pendingTasks
            }}</span>
        </button>
        <button pButton type="button" icon="pi pi-exclamation-triangle" class="productivity-action" [pTooltip]="'shell.incidents' | transloco"
          tooltipPosition="left" (click)="openProductivity('/productivity/incidents')">
          <span class="productivity-badge" *ngIf="productivitySummary.pendingIncidents">{{
            productivitySummary.pendingIncidents }}</span>
        </button>
      </div>
      <button pButton type="button" icon="pi pi-briefcase" class="productivity-main"
        (click)="toggleProductivityLauncher()">
        <span class="productivity-badge main" *ngIf="productivityTotalCount()">{{ productivityTotalCount() }}</span>
      </button>
    </div>
  </div>
</div>

<p-drawer [(visible)]="mobileSidebarVisible" [position]="navigationDirection() === 'rtl' ? 'right' : 'left'" [dismissible]="true" [modal]="true"
  styleClass="mobile-nav-drawer">
  <ng-template pTemplate="header">
    <a class="drawer-brand" routerLink="/dashboard" (click)="navigateHome($event)"
      [attr.aria-label]="'shell.goToHome' | transloco">
      <img src="/assets/logilink_logo_color.png" alt="LogiLink Logo">
      <span>LOGILINK</span>
    </a>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="drawer-shell">
      <nav class="drawer-nav" [attr.aria-label]="'shell.mobileNavigation' | transloco">
        @for (item of menu.visibleItems; track menu.trackItem($index, item)) {
        <ng-container
          *ngTemplateOutlet="navBranch; context: { $implicit: item, level: 0, mode: 'mobile' }"></ng-container>
        } @empty {
        <div class="nav-empty">{{ 'shell.noMatchingModules' | transloco }}</div>
        }
      </nav>
    </div>
  </ng-template>
</p-drawer>

<!-- AI Chat Drawer (right side, quick access) -->
<app-ai-chat-drawer [visible]="aiChatDrawerVisible"
    [stateContext]="aiChatStateContext"
    (visibleChange)="aiChatDrawerVisible = $event">
</app-ai-chat-drawer>
}

@if (!isLoggedIn && !authBootstrapInProgress) {
<div class="public-top-controls">
  @if (instanceTag) {
  <div class="public-instance-tag" [attr.title]="'shell.testInstance' | transloco" [attr.aria-label]="'shell.testInstance' | transloco">
    {{ instanceTag }}
  </div>
  }
  <button type="button" class="public-theme-toggle" (click)="toggleDarkMode()"
    [attr.aria-label]="'Switch to ' + themeToggleLabel()"
    [attr.title]="'Switch to ' + themeToggleLabel()">
    <i class="pi" [class.pi-moon]="!isDarkMode" [class.pi-sun]="isDarkMode"></i>
    <span>{{ isDarkMode ? ('shell.lightMode' | transloco) : ('shell.darkMode' | transloco) }}</span>
  </button>
</div>
<main class="app-content" [class.public-edge-to-edge]="isPublicEdgeToEdgeRoute()">
  <router-outlet></router-outlet>
</main>
}

@if (authBootstrapInProgress) {
<main class="app-content">
  <div class="loading-state">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ 'shell.restoringSession' | transloco }}</span>
  </div>
</main>
}

<ng-template #navBranch let-item let-level="level" let-mode="mode">
  <div class="nav-row-wrap" [class.top-level]="level === 0" [class.child-level]="level > 0"
    [class.expanded]="menu.isExpanded(item)" [class.has-children]="menu.hasChildren(item)"
    [class.mobile-mode]="mode === 'mobile'" [style.--nav-depth]="level">
    @if (menu.hasChildren(item)) {
    <button type="button" class="nav-row nav-group" [class.active]="menu.isActive(item)" [attr.title]="item.label"
      [attr.aria-label]="item.label" [attr.aria-expanded]="menu.isExpanded(item) && (mode !== 'desktop' || desktopNavExpanded)"
      (click)="menu.toggleGroup(item, $event)">
      <i [class]="'nav-icon ' + menu.icon(item)"></i>
      <span class="nav-label">{{ item.label }}</span>
      <i class="pi pi-chevron-right nav-caret" [class.expanded]="menu.isExpanded(item)"></i>
    </button>

    <div class="nav-children" [attr.aria-hidden]="!menu.isExpanded(item) || (mode === 'desktop' && !desktopNavExpanded)"
      [attr.inert]="menu.isExpanded(item) && (mode !== 'desktop' || desktopNavExpanded) ? null : ''">
      <div class="nav-children-inner">
        <div class="nav-flyout-title">{{ item.label }}</div>

        @if (menu.routerLink(item); as groupRoute) {
        <a class="nav-row nav-link nav-overview" [class.active]="menu.isExactActive(item)" [routerLink]="groupRoute"
          (click)="handleMenuNavigate()">
          <i [class]="'nav-icon ' + menu.icon(item)"></i>
          <span class="nav-label">{{ 'shell.overview' | transloco }}</span>
        </a>
        }

        @for (child of menu.childItems(item); track menu.trackItem($index, child)) {
        <ng-container
          *ngTemplateOutlet="navBranch; context: { $implicit: child, level: level + 1, mode: mode }"></ng-container>
        }
      </div>
    </div>
    } @else {
    @if (menu.routerLink(item); as route) {
    <a class="nav-row nav-link" [class.active]="menu.isExactActive(item)" [attr.title]="item.label" [attr.aria-label]="item.label"
      [routerLink]="route" (click)="handleMenuNavigate()">
      <i [class]="'nav-icon ' + menu.icon(item)"></i>
      <span class="nav-label">{{ item.label }}</span>
    </a>
    } @else {
    <button type="button" class="nav-row nav-link" [attr.title]="item.label" [attr.aria-label]="item.label" (click)="runMenuCommand(item, $event)">
      <i [class]="'nav-icon ' + menu.icon(item)"></i>
      <span class="nav-label">{{ item.label }}</span>
    </button>
    }
    }
  </div>
</ng-template>
